<template>
  <div
    id="sidebar"
    class="sidebar"
    :class="{'collapsed': collapsed}"
    v-click-outside="hideState"
  >
    <div class="sidebar-body">
      <nav
        class="nav-body nav"
        style="position:relative;"
      >
        <!-- NOTE: Note Logo -->
        <nav
          class="sidebar-head navbar navbar-light"
          @click="changeShowState"
        >
          <div class="sidebar-head-logo-icon-container">
            <img
              width="32px"
              :src="require('../assets/agently_logo.png')"
              alt="Logo"
              class="sidebar-head-logo-icon-grey"
            >
            <img
              width="32px"
              :src="require('../assets/agently_logo.png')"
              alt="Logo"
              class="sidebar-head-logo-icon"
            >
          </div>
          <img
            height="32px"
            :src="require('../assets/abeja_agently_title.png')"
            alt="Logo"
            class="sidebar-head-logo-title"
          >
        </nav>

        <!-- NOTE: Ietms -->
        <div>
          <a
            id="sidebarItemSmartScheduling"
            class="nav-link d-flex align-items-center"
            :class="{'active': isActive('SmartScheduling')}"
            target="_self"
            @click="routerPush('SmartScheduling')"
          >
            <div class="sidebar-item-icon-container">
              <i class="sidebar-item-icon smart-scheduling-icon far fa-calendar-check" />
            </div>
            <span class="sidebar-item-title">{{ $t("Menu.SmartScheduling") }}</span>
          </a>
        </div>
        <!-- NOTE: Admin or Owner Setting Item -->
        <div style="position:absolute;bottom:0;">
          <a
            class="nav-link d-flex align-items-center"
            @click="openState()"
          >
            <div class="sidebar-item-icon-container">
              <i class="sidebar-item-icon fas fa-heartbeat" />
            </div>
            <span class="sidebar-item-title"> {{ $t("Menu.Status") }} </span>
          </a>
          <!-- NOTE: 別のState -->
          <a
            v-if="isAbejaAdmin"
            id="sidebarItemAbejaOnly"
            class="nav-link d-flex align-items-center"
            :class="{'active': isActive('AdminLicense')}"
            @click="routerPush('AbejaAdmin')"
            target="_self"
          >
            <div class="sidebar-item-icon-container">
              <img
                height="32px"
                :src="require('../assets/abeja_logo_mono.png')"
                alt="Logo"
                class="sidebar-item-icon"
              >
            </div>
            <span class="sidebar-item-title">{{ $t('Menu.AbejaAdmin') }}</span>
          </a>
          <a
            v-if="showSettingIcon"
            id="sidebarItemAdminMenu"
            class="nav-link d-flex align-items-center"
            :class="{'active': isActive('Setting')}"
            @click="routerPush('Setting')"
            target="_self"
          >
            <div class="sidebar-item-icon-container">
              <i class="sidebar-item-icon fas fa-cog" />
            </div>
            <span class="sidebar-item-title">{{ $t('Menu.Setting') }}</span>
          </a>
        </div>
      </nav>

      <!-- NOTE: Footer for Side Menu -->
      <div class="nav-footer">
        <div class="language-switch-wrapper">
          <div class="lang-switch">
            <a
              :class="{'active': lang=='en'}"
              @click="changeLang('en')"
            >
              English
            </a>
            <div class="language-divider" />
            <a
              :class="{'active': lang=='ja'}"
              @click="changeLang('ja')"
            >
              日本語
            </a>
          </div>
        </div>
        <div
          class="sidebar-toggle"
          @click="changeShowState"
        >
          <i
            class="fas fa-chevron-right rotatable"
            :class="{'collapsed': collapsed}"
            aria-hidden="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { ROLE } from '@/config/constants'

export default {
  props: {
    collapsed: {
      type: Boolean,
      required: true
    },
    activeContent: {
      type: String,
      default: 'Scheduling'
    }
  },
  computed: {
    ...mapState([
      'lang'
    ]),
    ...mapState('auth', [
      'role',
      'isAbejaAdmin'
    ]),
    showSettingIcon() {
      return this.role === ROLE.Owner || this.role === ROLE.Admin
    }
  },
  methods: {
    ...mapActions([
      'setLanguage'
    ]),
    changeShowState () {
      this.$emit('changeShowSideMenu')
    },
    hideState () {
      this.$emit('hideSideMenu')
    },
    isActive (name) {
      return this.activeContent === name ? 'active' : false
    },
    changeLang(lang) {
      this.$vuetify.lang.current = lang
      this.setLanguage(lang)
    },
    routerPush(name) {
      if (this.$route.name !== name) this.$router.push({ name: name });
    },
    openState() {
      open('https://status.agently.abeja.io', '_blank')
    }
  }
}
</script>

<style scoped>
</style>
